import { contextualMenuState } from '@databases/contextual-menu/contextual-menu-state';
import { useSnapshot } from 'valtio';

/** Returns true if any view settings contextual menu is open. */
export const useIsAnyViewSettingsMenuOpen = (): boolean => {
  const snap = useSnapshot(contextualMenuState);
  return snap.isAnyViewSettingsMenuOpen();
};
